import React from 'react'

import { IconProps } from '../../../common/types'

const Notification: React.FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 17 16" fill="none">
      <path
        d="M10.8203 11.3333H14.1536L13.217 10.3967C12.963 10.1427 12.8203 9.79819 12.8203 9.43897V7.33334C12.8203 5.59171 11.7072 4.11006 10.1536 3.56094V3.33333C10.1536 2.59695 9.55665 2 8.82027 2C8.08389 2 7.48694 2.59695 7.48694 3.33333V3.56094C5.93335 4.11006 4.82027 5.59171 4.82027 7.33334V9.43897C4.82027 9.79819 4.67757 10.1427 4.42356 10.3967L3.48694 11.3333H6.82027M10.8203 11.3333V12C10.8203 13.1046 9.92484 14 8.82027 14C7.7157 14 6.82027 13.1046 6.82027 12V11.3333M10.8203 11.3333H6.82027"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Notification
